
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Table, { Row, Column } from 'components/Table'
import Code from 'components/Code'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`ThemeProvider`}</inlineCode></h3>
    <p>{`A helper component for theming. Injects the theme into all styled components anywhere
beneath it in the component tree, via the context API.
Check the section on `}<a parentName="p" {...{
        "href": "/docs/advanced#theming"
      }}>{`Theming`}</a>{`.`}</p>
    <Table head={['Props', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      <Code mdxType="Code">theme</Code>
    </Column>
    <Column mdxType="Column">
      An object that will be injected as <Code mdxType="Code">theme</Code> into all
      interpolations in styled components beneath the provider.
    </Column>
  </Row>
    </Table>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// import styled, { ThemeProvider } from 'styled-components'

const Box = styled.div\`
  color: \${props => props.theme.color};
\`

render(
  <ThemeProvider theme={{ color: 'mediumseagreen' }}>
    <Box>I'm mediumseagreen!</Box>
  </ThemeProvider>
)
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;